import {Component} from "@angular/core";

@Component({
    selector: 'accordion-content',
    template: require('./accordion.content.template.html')
})
export class AccordionContentComponent {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/accordion.content.component.ts